function generateGraphTicksFromPeriod(periodLength) {
  const ticks = [];
  for (let year = 5; year <= periodLength; year += 5) {
    ticks.push(year);
  }
  return ticks;
}

export default generateGraphTicksFromPeriod;
